import { render, staticRenderFns } from "./ElementPage.vue?vue&type=template&id=ed25d4d0"
import script from "./ElementPage.vue?vue&type=script&lang=js"
export * from "./ElementPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports